<template>
  <div class="background_box">
    <div class="laws_statute">
      <div class="case">
        <el-breadcrumb
          separator-class="el-icon-arrow-right"
          style="margin: 10px 0"
        >
          <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item>
            <span
              class="case01"
              @click="toCase"
              style="font-weight: 700; cursor: pointer"
              >法律法规</span
            ></el-breadcrumb-item
          >
          <el-breadcrumb-item>高级检索</el-breadcrumb-item>
        </el-breadcrumb>
        <div class="advanced_search">
          <div style="margin: 0 0 0 100px">
            <el-form
              ref="form"
              :model="searchParameter"
              label-width="80px"
              :inline="true"
              style="width: 1000px"
              class="advancedDown"
            >
              <el-form-item label="标题">
                <el-input
                  v-model.trim="searchParameter.title"
                  placeholder="请输入标题"
                  @keyup.enter.native="onSubmit"
                  clearable
                ></el-input>
              </el-form-item>
              <el-form-item label="全文">
                <el-input
                  v-model.trim="searchParameter.content"
                  placeholder="请输入全文"
                  @keyup.enter.native="onSubmit"
                  clearable
                ></el-input>
              </el-form-item>
              <el-form-item label="发文字号">
                <el-input
                  v-model.trim="searchParameter.iss_num"
                  @keyup.enter.native="onSubmit"
                  placeholder="请输入发文字号"
                  clearable
                ></el-input>
              </el-form-item>
              <el-form-item label="发布年份">
                <el-date-picker
                  v-model="publish_time"
                  type="year"
                  placeholder="选择开始时间"
                  align=""
                  format="yyyy 年"
                  value-format="yyyy"
                  style="width: 48%"
                  clearable
                  :picker-options="pickerStartAuditYear"
                >
                </el-date-picker
                ><span style="margin: 0 1%">-</span
                ><el-date-picker
                  v-model="publish_endTime"
                  type="year"
                  placeholder="选择截止时间"
                  align=""
                  format="yyyy 年"
                  value-format="yyyy"
                  style="width: 48%"
                  clearable
                  :picker-options="pickerEndAuditYear"
                >
                </el-date-picker>
              </el-form-item>
              <el-form-item label="效力级别" >
                <el-select
                  v-model="eff_levelLabel"
                  filterable
                  placeholder="请选择"
                  clearable
                >
                  <el-option
                    v-for="(item, index) in eff_options"
                    :key="item.value + index"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="专题分类" >
                <el-select
                  v-model="thematic_classLabel"
                  filterable
                  placeholder="请选择"
                  clearable
                >
                  <el-option
                    v-for="(item, index) in thematic_options"
                    :key="item.value + index"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="发布部门" >
                <el-select
                  v-model="pub_departmentLabel"
                  filterable
                  placeholder="请选择"
                  clearable
                >
                  <el-option
                    v-for="(item, index) in pub_options"
                    :key="item.value + index"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="时效性" >
                <el-select
                  v-model="timelinessLabel"
                  filterable
                  placeholder="请选择"
                  clearable
                >
                  <el-option
                    v-for="(item, index) in timeliness_options"
                    :key="item.value + index"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="法规类别">
                <el-select
                  v-model="reg_categoryLabel"
                  filterable
                  placeholder="请选择"
                  clearable
                >
                  <el-option
                    v-for="(item, index) in reg_options"
                    :key="item.value + index"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="文书分类" v-if="Category_options.length > 0">
                <el-select
                  v-model="CategoryLabel"
                  filterable
                  placeholder="请选择"
                  clearable
                >
                  <el-option
                    v-for="(item, index) in Category_options"
                    :key="item.value + index"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item size="large" class="searchBtn">
                <el-button
                  type="primary"
                  @click="onSubmit"
                  style="background: rgb(250, 208, 93); color: white"
                  >开始检索</el-button
                >
                <el-button
                  style="background: rgb(63, 27, 2); color: white"
                  @click="resetForm('form')"
                  >重置条件</el-button
                >
              </el-form-item>
            </el-form>
          </div>
        </div>
        <!-- 搜索条件  -->
        <div class="conditions">
              <div class="condition">
                <span style="position: absolute">搜索条件</span>
                <span class="eltags">
                  <el-tag closable type="warning" v-for="(item, ind) in regulations" :key="ind + 'item'"
                    @close="handleClose(item.type, ind)">
                    
          
                      <span v-if="item.type == 'title'">标题：</span>
                      <span v-if="item.type == 'text'">全文：</span>
                      <span v-if="item.type == 'hyphen'">发文字号：</span>
                    <span v-if="item.type == 'Eff'">效力级别：</span>
                    <span v-if="item.type == 'Pub'">发布部门：</span>
                    <span v-if="item.type == 'Time'">发布年份：</span>
                    <span v-if="item.type == 'Aging'">时效性：</span>
                    <span v-if="item.type == 'Reg'">法规类别：</span>
                    <span v-if="item.type == 'Topic'">专题分类：</span>
                    <span v-if="item.type == 'doc'">文书分类：</span>
                    <span>{{ item.name }}</span>
                  </el-tag></span>
              </div>
              <div class="savebtn">
                <i class="el-icon-delete" @click="remove">清空条件</i>
              </div>
            </div>
        <div class="box_botton" style="">
          <div class="box_left">
            <el-menu
              default-active="2"
              class="el-menu-vertical-demo"
              :default-openeds="openeds"
            >
              <!-- <el-submenu index="0">
              <template slot="title">
                <img
                  src="../../../assets/imgs/img_532508.png"
                  alt=""
                  style="width: 0.42rem; height: 0.50rem; margin-right: 0.25rem"
                />
                <span class="imgTitle" style="font-weight: 900; font-size: 0.30rem"
                  >相关提示</span
                >
              </template>
              <div style="">
                <span
                  style="
                    height: 1.00rem;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                  "
                  >暂无数据</span
                >
              </div>
            </el-submenu> -->
              <el-submenu index="1" v-if="Eff_level.length > 0">
                <template slot="title">
                  <img
                    src="../../../assets/imgs/法律法规图标/效力级别.png"
                    alt=""
                    style="width: 30px; height: 30px; margin-right: 10px"
                  />
                  <span
                    class="imgTitle"
                    style="font-weight: 900; font-size: 18px"
                    >效力级别</span
                  >
                </template>
                <!-- <div style="" v-if="Eff_level.length == 0">
                <span
                  style="
                    height: 1.00rem;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                  "
                  >暂无数据</span
                >
              </div> -->
                <div class="sift_tree">
                  <el-tree
                    :data="levelAll ? Eff_level : Eff_level.slice(0, 10)"
                    :props="level"
                    v-loading="loadNode"
                    element-loading-text="拼命加载中"
                    element-loading-spinner="el-icon-loading"
                    element-loading-background="rgb(250, 242, 234)"
                    @node-click="
                      (data, node, item) =>
                        briefClick(data, node, item, 'Eff_level')
                    "
                    class="region"
                    style="padding-left: 20px"
                  >
                    <span class="custom-tree-node" slot-scope="{ node, data }">
                      <span style="line-height: 20px"
                        ><span style="font-weight: 900 !important">{{
                          data.name
                        }}</span
                        >({{ data.count }})</span
                      >
                      <!-- <span style="font-weight: 900 !important;"></span> -->
                    </span>
                  </el-tree>
                  <span
                    class="more"
                    v-if="Eff_level.length > 10"
                    @click="showAll('Eff_level')"
                    v-show="levelShow"
                    >查看更多</span
                  >
                </div>
              </el-submenu>
              <el-submenu index="2" v-if="Thematic.length > 0">
                <template slot="title">
                  <img
                    src="../../../assets/imgs/法律法规图标/专题分类.png"
                    alt=""
                    style="width: 30px; height: 30px; margin-right: 10px"
                  />
                  <span
                    class="imgTitle"
                    style="font-weight: 900; font-size: 18px"
                    >专题分类</span
                  >
                </template>
                <!-- <div style="">
                <span
                  style="
                    height: 1.00rem;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                  "
                  >暂无数据</span
                >
              </div> -->
                <div class="sift_tree"></div>
                <el-tree
                  :data="thematicAll ? Thematic : Thematic.slice(0, 10)"
                  :props="thematic"
                  v-loading="loadNode"
                  element-loading-text="拼命加载中"
                  element-loading-spinner="el-icon-loading"
                  element-loading-background="rgb(250, 242, 234)"
                  @node-click="
                    (data, node, item) =>
                      briefClick(data, node, item, 'Thematic')
                  "
                  class="region"
                  style="padding-left: 20px"
                >
                  <span class="custom-tree-node" slot-scope="{ node, data }">
                    <span style="line-height: 20px">
                      <span style="font-weight: 900 !important">{{
                        data.name
                      }}</span
                      >({{ data.count }})</span
                    >
                    <!-- <span></span> -->
                  </span>
                </el-tree>
                <span
                  class="more"
                  v-if="Thematic.length > 10"
                  @click="showAll('Thematic')"
                  v-show="thematicShow"
                  >查看更多</span
                >
              </el-submenu>
              <el-submenu index="7" v-if="DocCategory.length > 0">
                <template slot="title">
                  <img
                    src="../../../assets/imgs/法律法规图标/文书分类.png"
                    alt=""
                    style="width: 30px; height: 30px; margin-right: 10px"
                  />
                  <span
                    class="imgTitle"
                    style="font-weight: 900; font-size: 18px"
                    >文书分类</span
                  >
                </template>
                <!-- <div style="">
                <span
                  style="
                    height: 1.00rem;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                  "
                  >暂无数据</span
                >
              </div> -->
                <div class="sift_tree">
                  <el-tree
                    :data="CategoryAll ? DocCategory : DocCategory.slice(0, 10)"
                    :props="catecgoryment"
                    v-loading="loadNode"
                    element-loading-text="拼命加载中"
                    element-loading-spinner="el-icon-loading"
                    element-loading-background="rgb(250, 242, 234)"
                    @node-click="
                      (data, node, item) =>
                        briefClick(data, node, item, 'DocCategory')
                    "
                    class="region"
                    style="padding-left: 20px"
                  >
                    <span class="custom-tree-node" slot-scope="{ node, data }">
                      <span style="line-height: 20px">
                        <span style="font-weight: 900 !important">{{
                          data.name
                        }}</span>
                        ({{ data.count }})</span
                      >
                      <!-- <span></span> -->
                    </span>
                  </el-tree>
                  <span
                    class="more"
                    v-if="Pub_Department.length > 10"
                    @click="showAll('Pub_Department')"
                    v-show="CategoryShow"
                    >查看更多</span
                  >
                </div>
              </el-submenu>
              <el-submenu index="3">
                <template slot="title">
                  <img
                    src="../../../assets/imgs/法律法规图标/发布部门.png"
                    alt=""
                    style="width: 30px; height: 30px; margin-right: 10px"
                  />
                  <span
                    class="imgTitle"
                    style="font-weight: 900; font-size: 18px"
                    >发布部门</span
                  >
                </template>
                <!-- <div style="">
                <span
                  style="
                    height: 1.00rem;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                  "
                  >暂无数据</span
                >
              </div> -->
                <div class="sift_tree">
                  <el-tree
                    :data="
                      departmentAll
                        ? Pub_Department
                        : Pub_Department.slice(0, 10)
                    "
                    :props="department"
                    v-loading="loadNode"
                    element-loading-text="拼命加载中"
                    element-loading-spinner="el-icon-loading"
                    element-loading-background="rgb(250, 242, 234)"
                    @node-click="
                      (data, node, item) =>
                        briefClick(data, node, item, 'Pub_Department')
                    "
                    class="region cityClass"
                    style="padding-left: 20px"
                  >
                    <span class="custom-tree-node" slot-scope="{ node, data }">
                      <span style="line-height: 20px"
                        ><span style="font-weight: 900 !important">{{
                          data.name
                        }}</span
                        >({{ data.count }})</span
                      >
                      <!-- <span></span> -->
                    </span>
                  </el-tree>
                  <span
                    class="more"
                    v-if="Pub_Department.length > 10"
                    @click="showAll('Pub_Department')"
                    v-show="departmentShow"
                    >查看更多</span
                  >
                </div>
              </el-submenu>

              <el-submenu index="4" v-if="Timeliness.length > 0">
                <template slot="title">
                  <img
                    src="../../../assets/imgs/法律法规图标/时效性.png"
                    alt=""
                    style="width: 30px; height: 30px; margin-right: 10px"
                  />
                  <span
                    class="imgTitle"
                    style="font-weight: 900; font-size: 18px"
                    >时效性</span
                  >
                </template>
                <!-- <div style="">
                <span
                  style="
                    height: 1.00rem;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                  "
                  >暂无数据</span
                >
              </div> -->
                <div class="sift_tree">
                  <el-tree
                    :data="timelinesAll ? Timeliness : Timeliness.slice(0, 10)"
                    :props="timelines"
                    v-loading="loadNode"
                    element-loading-text="拼命加载中"
                    element-loading-spinner="el-icon-loading"
                    element-loading-background="rgb(250, 242, 234)"
                    @node-click="
                      (data, node, item) =>
                        briefClick(data, node, item, 'Timeliness')
                    "
                    class="region"
                    style="padding-left: 23px"
                  >
                    <span class="custom-tree-node" slot-scope="{ node, data }">
                      <span style="line-height: 20px"
                        ><span style="font-weight: 900 !important">{{
                          data.key
                        }}</span>
                        ({{ data.doc_count }})</span
                      >
                      <!-- <span></span> -->
                    </span>
                  </el-tree>
                  <span
                    class="more"
                    v-if="Timeliness.length > 10"
                    @click="showAll('Timeliness')"
                    v-show="timelinesShow"
                    >查看更多</span
                  >
                </div>
              </el-submenu>
              <el-submenu index="5" v-if="Reg_Category.length > 0">
                <template slot="title">
                  <img
                    src="../../../assets/imgs/法律法规图标/法规类别.png"
                    alt=""
                    style="width: 30px; height: 30px; margin-right: 10px"
                  />
                  <span
                    class="imgTitle"
                    style="font-weight: 900; font-size: 18px"
                    >法规类别</span
                  >
                </template>
                <!-- <div style="">
                <span
                  style="
                    height: 1.00rem;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                  "
                  >暂无数据</span
                >
              </div> -->
                <div class="sift_tree">
                  <el-tree
                    :data="
                      categoryAll ? Reg_Category : Reg_Category.slice(0, 10)
                    "
                    :props="category"
                    v-loading="loadNode"
                    element-loading-text="拼命加载中"
                    element-loading-spinner="el-icon-loading"
                    element-loading-background="rgb(250, 242, 234)"
                    @node-click="
                      (data, node, item) =>
                        briefClick(data, node, item, 'Reg_Category')
                    "
                    class="region"
                    style="padding-left: 20px"
                  >
                    <span class="custom-tree-node" slot-scope="{ node, data }">
                      <span style="line-height: 20px"
                        ><span style="font-weight: 900 !important">{{
                          data.name
                        }}</span
                        >({{ data.count }})</span
                      >
                      <!-- <span></span> -->
                    </span>
                  </el-tree>
                  <span
                    class="more"
                    v-if="Reg_Category.length > 10"
                    @click="showAll('Reg_Category')"
                    v-show="categoryShow"
                    >查看更多</span
                  >
                </div>
              </el-submenu>
              <el-submenu index="6" v-if="Pub_Time.length > 0">
                <template slot="title">
                  <img
                    src="../../../assets/imgs/法律法规图标/发布年份.png"
                    alt=""
                    style="width: 30px; height: 30px; margin-right: 10px"
                  />
                  <span
                    class="imgTitle"
                    style="font-weight: 900; font-size: 18px"
                    >发布年份</span
                  >
                </template>
                <!-- <div style="">
                <span
                  style="
                    height: 1.00rem;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                  "
                  >暂无数据</span
                >
              </div> -->
                <div class="sift_tree">
                  <el-tree
                    :data="timeAll ? Pub_Time : Pub_Time.slice(0, 10)"
                    :props="time"
                    v-loading="loadNode"
                    element-loading-text="拼命加载中"
                    element-loading-spinner="el-icon-loading"
                    element-loading-background="rgb(250, 242, 234)"
                    @node-click="
                      (data, node, item) =>
                        briefClick(data, node, item, 'Pub_Time')
                    "
                    class="region"
                    style="padding-left: 23px"
                  >
                    <span class="custom-tree-node" slot-scope="{ node, data }">
                      <span style="line-height: 20px">
                        <span style="font-weight: 900 !important">{{
                          data.key_as_string
                        }}</span
                        >({{ data.doc_count }})</span
                      >
                      <!-- <span></span> -->
                    </span>
                  </el-tree>
                  <span
                    class="more"
                    v-if="Pub_Time.length > 10"
                    @click="showAll('Pub_Time')"
                    v-show="timeShow"
                    >查看更多</span
                  >
                </div>
              </el-submenu>
            </el-menu>
          </div>
          <div class="box_right">
            <div class="box_right_top">
              <div style="display: flex">
                <span style="line-height: 40px"
                  ><span style="margin-right: 20px"
                    >共<span style="color: #cf8700">{{ totalCount }}</span
                    >篇</span
                  ></span
                >
                <div>
                  <span style="margin-right: 10px">法规类别</span>
                  <el-select
                    v-model="type_vue"
                    placeholder="请选择"
                    @change="laws_Type"
                    class="bac"
                  >
                    <el-option
                      v-for="item in lawsType"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                      <span>{{ item.label }}</span>
                    </el-option>
                  </el-select>
                </div>
              </div>

              <div>
                <span style="margin-right: 10px" v-if="sortShow">分组</span>
                <el-select
                  v-model="group"
                  placeholder="请选择"
                  v-if="sortShow"
                  size="mini"
                  style="width: 95px"
                  @change="packet"
                  class="bac"
                >
                  <el-option
                    v-for="item in groupsType"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                    <span>{{ item.label }}</span>
                  </el-option>
                </el-select>

                <span style="margin: 0 10px" v-if="sortShow">排序方式</span>
                <el-select
                  v-model="valuesort"
                  placeholder="请选择"
                  v-if="sortShow"
                  size="mini"
                  style="width: 110px"
                  class="bac"
                >
                  <el-option
                    v-for="item in defaultsort"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                    <span @click="itemsort(item.value, item.label)">{{
                      item.label
                    }}</span>
                  </el-option>
                </el-select>
                <el-button-group
                  style="margin-left: 20px"
                  class="types"
                  element-loading-spinner="el-icon-loading"
                  v-if="searchParameter.type !== '法律文书'"
                >
                  <el-button
                    @click="dataType('chart')"
                    :class="picked ? 'listPick' : 'EChart'"
                    >列表化</el-button
                  >
                  <el-button
                    @click="dataType('list')"
                    :class="picked ? 'EChart' : 'listPick'"
                    >可视化</el-button
                  >
                </el-button-group>
              </div>
            </div>
            <div
              class="box_main"
              v-loading="loading_box"
              v-if="picked"
              element-loading-text="拼命加载中"
              element-loading-spinner="el-icon-loading"
              style="min-height: 500px"
              element-loading-background="rgba(255, 255, 255, 0.5)"
            >
              <div
                v-if="totalCount == 0 && categoryList.length <= 0"
                style="
                  display: flex;
                  justify-content: center;
                  align-items: center;
                  height: 500px;
                "
              >
                <div>
                  <img src="../Case/kongkong.png" alt="" />
                  <div style="text-align: center; font-size: 20px">
                    暂无数据
                  </div>
                </div>
              </div>
              <div v-if="lawList.length > 0">
                <div
                  class="box_main_list"
                  v-for="(item, index) in lawList"
                  :key="index"
                >
                  <!-- /lawsDetail -->
                  <div class="title">
                    <router-link
                      :to="{
                        path: `/lawsDetail/${item._id}`,
                        query: { type: item._source.type },
                      }"
                      target="_blank"
                    >
                      <span style="position: absolute; top: 0px">{{
                        index + 1 + "、"
                      }}</span>
                      <el-tag
                        v-if="
                          item._source.Timeliness == '现行有效' ||
                          item._source.Timeliness == '已被修改'
                        "
                        >{{ item._source.Timeliness }}</el-tag
                      >
                      <el-tag
                        type="info"
                        v-else-if="item._source.Timeliness == '尚未生效'"
                        >{{ item._source.Timeliness }}</el-tag
                      >
                      <el-tag
                        type="warning"
                        v-else-if="item._source.Timeliness == '部分失效'"
                        >{{ item._source.Timeliness }}</el-tag
                      >
                      <el-tag
                        type="danger"
                        v-else-if="item._source.Timeliness == '失效'"
                        >&ensp;失&emsp;效&ensp;</el-tag
                      ><el-tag
                          type="info"
                          v-else
                          >{{item._source.Timeliness}}</el-tag
                        >
                      <h2
                        style="
                          display: inline-block;
                          font-weight: 500;
                          font-size: 16px;
                          cursor: pointer;
                          width: 800px;
                          word-break: normal;
                          margin-left: 100px;
                          line-height: 32px;
                        "
                        v-html="item._source.Title"
                      >
          
                      </h2>
                    </router-link>
                     <div style="display: flex">
                      <div class="collection" v-if="!item._source.coll">
                        <el-tooltip
                          content="收藏"
                          placement="left"
                          effect="light"
                        >
                          <img
                            @click="collectible(item)"
                            src="../../../assets/imgs/2.0/_收藏.png"
                            alt=""
                          />
                        </el-tooltip>
                      </div>
                      <div class="collection" v-if="item._source.coll">
                        <el-tooltip
                          content="收藏"
                          placement="left"
                          effect="light"
                        >
                          <img
                            v-if="item._source.coll == 0"
                            @click="collectible(item)"
                            src="../../../assets/imgs/2.0/_收藏.png"
                            alt=""
                          />
                        </el-tooltip>
                        <el-popconfirm
                          title="确认取消收藏吗？"
                          @confirm="cancel(item)"
                        >
                          <img
                            slot="reference"
                            v-if="item._source.coll == 1"
                            src="../../../assets/imgs/2.0/收藏3.png"
                            alt=""
                          />
                        </el-popconfirm>
                      </div>
                      <el-dropdown style="height: 28px; margin: 0px 10px">
                        <!-- <el-button type="primary" size="mini" style="height: 28px"
                    >下载</el-button
                  > -->
                        <el-button
                          type="warning"
                          icon="el-icon-download"
                          circle
                          size="mini"
                        ></el-button>
                        <!-- <i class="el-icon-download"></i> -->
                        <el-dropdown-menu slot="dropdown">
                          <el-dropdown-item
                            ><span @click="down(item._id, 'pdf')"
                              ><img
                                class="down_icon"
                                src="../../../assets/imgs/图标/pdf (1).png"
                                alt=""
                              />
                              PDF文件</span
                            ></el-dropdown-item
                          >
                          <el-dropdown-item
                            ><span @click="down(item._id, 'word')"
                              ><img
                                class="down_icon"
                                src="../../../assets/imgs/图标/word.png"
                                alt=""
                              />
                              WORD文件</span
                            ></el-dropdown-item
                          >
                        </el-dropdown-menu>
                      </el-dropdown>
                    </div>
                  </div>
                  <div style="margin: 10px 0 10px 25px" class="message">
                    <el-breadcrumb separator="/">
                      <el-breadcrumb-item>{{
                        item._source.Timeliness
                      }}</el-breadcrumb-item>
                      <el-breadcrumb-item v-if="item._source.Iss_Num">{{
                        item._source.Iss_Num
                      }}</el-breadcrumb-item>
                      <el-breadcrumb-item
                        >{{ item._source.Pub_Time }}发布</el-breadcrumb-item
                      >
                      <el-breadcrumb-item v-if="item._source.Imp_Time">{{
                        item._source.Imp_Time
                      }}</el-breadcrumb-item>
                    </el-breadcrumb>
                   
                    <!-- <div style="margin: 10px 0">
                  <el-button size="mini" round>本法变迁</el-button>
                  <el-button size="mini" round>相关案例</el-button>
                  <el-button size="mini" round>引用统计</el-button>
                  <el-button size="mini" round>智能发现</el-button>
                </div> -->
                  </div>
                  <div class="card">
                    <el-tabs type="border-card" v-if="item._source.retrieval">
                      <el-tab-pane
                        v-if="item._source.retrieval.word_times"
                        :label="
                          '命中' +
                          '(' +
                          item._source.retrieval.word_times.times +
                          ')'
                        "
                      >
                        <div>
                          <div
                            v-for="(items, index) in item._source.retrieval.par"
                            :key="index + '04'"
                          >
                            <div class="hits">
                              <span
                                style="width: 800px; line-height: 25px"
                                v-html="items"
                              ></span>
                            </div>
                          </div>
                        </div>

                        <div class="mores">
                          <router-link
                            :to="{
                              path: `/lawsDetail/${item._id}`,
                              query: {
                                type: item._source.type,
                                keyword: input,
                                radio: radio01,
                              },
                            }"
                            target="_blank"
                          >
                            <span>更多请查看原文</span>
                          </router-link>
                        </div></el-tab-pane
                      >
                    </el-tabs>
                  </div>
                  <!-- <div class="box_detail"></div> -->
                  <el-divider></el-divider>
                </div>
                <div class="page-bar" v-if="picked">
                  <el-pagination
                    background
                    layout="prev, pager, next"
                    :total="totalCount > 10000 ? 10000 : totalCount"
                    @current-change="handleCurrentChange"
                    :current-page.sync="current_page"
                    :page-size="20"
                  >
                  </el-pagination>
                </div>
              </div>
              <div style="margin-bottom: 20px" v-if="lawList.length == 0">
                <div
                  class="box_main_list"
                  v-for="(item_category, index) in categoryList"
                  :key="index"
                >
                  <div class="grouping-title">
                    <h3 @click="moreLevel(item_category.Maxti)">
                      {{ item_category.Maxti }}({{
                        item_category.list.total.value
                      }})
                    </h3>
                    <span
                      class="packMore"
                      @click="moreLevel(item_category.Maxti)"
                      >更多 >>
                    </span>
                  </div>

                  <div
                    class="box_main_list"
                    style="margin: 0 0 20px 0"
                    v-for="(item, index) in item_category.list.hits.slice(0, 8)"
                    :key="index"
                  >
                    <!-- /lawsDetail -->
                    <div class="title">
                      <router-link
                        :to="{
                          path: `/lawsDetail/${item._id}`,
                          query: { type: item._source.type },
                        }"
                        target="_blank"
                      >
                        <span style="position: absolute; top: 0px">{{
                          index + 1 + "、"
                        }}</span>
                        <span v-if="type_vue !== '法律文书'"
                          ><el-tag
                            v-if="
                              item._source.Timeliness == '现行有效' ||
                              item._source.Timeliness == '已被修改'
                            "
                            >{{ item._source.Timeliness }}</el-tag
                          >
                          <el-tag
                            type="info"
                            v-else-if="item._source.Timeliness == '尚未生效'"
                            >{{ item._source.Timeliness }}</el-tag
                          >
                          <el-tag
                            type="warning"
                            v-else-if="item._source.Timeliness == '部分失效'"
                            >{{ item._source.Timeliness }}</el-tag
                          >
                          <el-tag
                            type="danger"
                            v-else-if="item._source.Timeliness == '失效'"
                            >&ensp;失&emsp;效&ensp;</el-tag
                          >
                          <el-tag
                            type="info"
                            v-else
                            >{{ item._source.Timeliness }}</el-tag
                          ></span
                        >
                        <h2
                          style="
                            display: inline-block;
                            font-weight: 500;
                            font-size: 16px;
                            cursor: pointer;
                            width: 800px;
                            word-break: normal;

                            line-height: 32px;
                          "
                          :style="
                            type_vue !== '法律文书'
                              ? 'margin-left: 100px;'
                              : 'margin-left: 16px;'
                          "
                          v-html="item._source.Title"
                        >
                          <!-- {{ item._source.Casename }} -->
                        </h2>
                      </router-link>
                      <div style="display: flex">
                        <div class="collection" v-if="!item._source.coll">
                          <el-tooltip
                            content="收藏"
                            placement="left"
                            effect="light"
                          >
                            <img
                              @click="collectible(item)"
                              src="../../../assets/imgs/2.0/_收藏.png"
                              alt=""
                            />
                          </el-tooltip>
                        </div>
                        <div class="collection" v-if="item._source.coll">
                          <el-tooltip
                            content="收藏"
                            placement="bottom"
                            effect="light"
                          >
                            <img
                              v-if="item._source.coll == 0"
                              @click="collectible(item)"
                              src="../../../assets/imgs/2.0/_收藏.png"
                              alt=""
                            />
                          </el-tooltip>
                          <el-popconfirm
                            title="确认取消收藏吗？"
                            @confirm="cancel(item)"
                          >
                            <img
                              slot="reference"
                              v-if="item._source.coll == 1"
                              src="../../../assets/imgs/2.0/收藏3.png"
                              alt=""
                            />
                          </el-popconfirm>
                        </div>
                        <el-dropdown style="height: 28px; margin: 0px 10px">
                          <!-- <el-button type="primary" size="mini" style="height: 28px"
                    >下载</el-button
                  > -->
                          <el-button
                            type="warning"
                            icon="el-icon-download"
                            circle
                            size="mini"
                          ></el-button>
                          <!-- <i class="el-icon-download"></i> -->
                          <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item
                              ><span @click="down(item._id, 'pdf')"
                                ><img
                                  class="down_icon"
                                  src="../../../assets/imgs/图标/pdf (1).png"
                                  alt=""
                                />
                                PDF文件</span
                              ></el-dropdown-item
                            >
                            <el-dropdown-item
                              ><span @click="down(item._id, 'word')"
                                ><img
                                  class="down_icon"
                                  src="../../../assets/imgs/图标/word.png"
                                  alt=""
                                />
                                WORD文件</span
                              ></el-dropdown-item
                            >
                          </el-dropdown-menu>
                        </el-dropdown>
                      </div>
                    </div>
                    <div style="margin: 10px 0 10px 25px" class="message">
                      <el-breadcrumb separator="/">
                        <el-breadcrumb-item>{{
                          item._source.Timeliness
                        }}</el-breadcrumb-item>
                        <el-breadcrumb-item v-if="item._source.Iss_Num">{{
                          item._source.Iss_Num
                        }}</el-breadcrumb-item>
                        <el-breadcrumb-item
                          >{{ item._source.Pub_Time }}发布</el-breadcrumb-item
                        >
                        <el-breadcrumb-item v-if="item._source.Imp_Time">{{
                          item._source.Imp_Time
                        }}</el-breadcrumb-item>
                      </el-breadcrumb>
                      
                      <!-- <div style="margin: 10px 0">
                  <el-button size="mini" round>本法变迁</el-button>
                  <el-button size="mini" round>相关案例</el-button>
                  <el-button size="mini" round>引用统计</el-button>
                  <el-button size="mini" round>智能发现</el-button>
                </div> -->
                    </div>
                    <div class="card">
                      <el-tabs type="border-card" v-if="item._source.retrieval">
                        <el-tab-pane
                          v-if="item._source.retrieval.word_times"
                          :label="
                            '命中' +
                            '(' +
                            item._source.retrieval.word_times.times +
                            ')'
                          "
                        >
                          <div>
                            <div
                              v-for="(items, index) in item._source.retrieval
                                .par"
                              :key="index + '04'"
                            >
                              <div class="hits">
                                <span
                                  style="width: 800px; line-height: 25px"
                                  v-html="items"
                                ></span>
                              </div>
                            </div>
                          </div>

                          <div class="mores">
                            <router-link
                              :to="{
                                path: `/lawsDetail/${item._id}`,
                                query: {
                                  type: item._source.type,
                                  keyword: input,
                                  radio: radio01,
                                },
                              }"
                              target="_blank"
                            >
                              <span>更多请查看原文</span>
                            </router-link>
                          </div></el-tab-pane
                        >
                      </el-tabs>
                    </div>
                    <!-- <div class="box_detail"></div> -->
                    <el-divider></el-divider>
                  </div>
                  <!-- <div class="more" v-if="item_category.list.hits.length > 7">
                  <el-button
                    class="packMore"
                    type="text"
                    icon="el-icon-view"
                    @click="moreLevel(item_category.Maxti)"
                    >更多</el-button
                  >
                </div> -->
                </div>
              </div>
            </div>
            <div
              class="ECharts_main"
              v-loading="loadNode"
              element-loading-text="拼命加载中"
              element-loading-spinner="el-icon-loading"
              style="min-height: 500px; margin: 10px 0"
              element-loading-background="rgba(255, 255, 255, 0.5)"
              v-if="!picked"
            >
              <CHART
                :eChars="leftData"
                v-loading="loadNode"
                v-if="update"
              ></CHART>
            </div>
          </div>
        </div>
      </div>
      <ComFooter></ComFooter>
    </div>
  </div>
</template>

<script>
import store from "@/store";
import CHART from "../lawsStatute/component/charts.vue";
import ComFooter from "../../../components/ComFooter.vue";
export default {
  components: {
    CHART,
    ComFooter,
  },
  data() {
    return {
      update: true,
      openeds: ["1", "2", "3", "4", "5", "6", "7"], //侧边栏
      radio01: "1", //精准 / 模糊检索
      input: "", //检索框
      searchParameter: {
        page: 1,
        pagesize: 20,
        search: "", //文本框检索
        iss_num: "", //发文字号
        pub_time: "", //发布日期
        imp_time: "", //实施日期
        timeliness: "", //时效性
        eff_level: "", //效力级别
        reg_category: "", //法规类别
        failure_basis: "", //失效依据
        content: "", //全文
        pub_department: "", //发布部门
        title: "", //标题
        thematic_class: "", //专题分类
        // iss_num: "", //发文字号
        type: "", //类型：中央法规；地方法规 ;法律文书
        order: "", //排序
        doc_category: "",
      },
      type_vue: "中央法规",
      search_Vue: { word: "", type: "1", field: "title" }, //文本框检索
      pub_time_Vue: { start: "", end: "" }, //发布日期
      imp_time_Vue: { start: "", end: "" }, //实施日期
      order_vue: { field: "Pub_Time", type: "desc" }, //排序方式

      //   筛选数据
      Eff_level: [], //效力级别
      Pub_Department: [], //发布部门
      Pub_Time: [], //发布年份
      Reg_Category: [], //法规类别
      Thematic: [], //专题分类
      Timeliness: [], //时效性
      DocCategory: [],
      level: {
        children: "children",
        label: "key",
      },
      levelAll: false,
      levelShow: true,
      department: {
        children: "children",
        label: "key",
      },
      CategoryAll: false,
      CategoryShow: true,
      catecgoryment: {
        children: "children",
        label: "key",
      },
      departmentAll: false,
      departmentShow: true,
      thematic: {
        children: "children",
        label: "key",
      },
      thematicAll: false,
      thematicShow: true,
      timelines: {
        children: "children",
        label: "key",
      },
      timelinesAll: false,
      timelinesShow: true,
      category: {
        children: "children",
        label: "key",
      },
      categoryAll: false,
      categoryShow: true,
      time: {
        children: "children",
        label: "key",
      },
      timeAll: false,
      timeShow: true,
      loadNode: true,
      totalCount: 0, //检索结果数量
      sortShow: true,
      group: "效力级别",
      groupsType: [
        {
          value: "效力级别",
          label: "效力级别",
        },
        {
          value: "时效性",
          label: "时效性",
        },
        {
          value: "",
          label: "不分组",
        },
      ],
      valuesort: "desc0",
      defaultsort: [
        {
          value: "",
          label: "相关度",
        },
        {
          value: "asc",
          label: "↑ 发布时间",
        },
        {
          value: "desc",
          label: "↓ 发布时间",
        },
        {
          value: "asc0",
          label: "↑ 实施时间",
        },
        {
          value: "desc0",
          label: "↓ 实施时间",
        },
      ],
      picked: true,
      lawList: "",
      loadNode: true,
      loading_box: true,
      regulations: [], //检索、筛选条件
      leftData: "",
      publish_time: "",
      publish_endTime: "",
      eff_options: [],
      thematic_options: [],
      pub_options: [],
      timeliness_options: [],
      reg_options: [],
      Category_options: [],
      pickerStartAuditYear: {
        disabledDate: (time) => {
          if (this.publish_endTime) {
            return time.getFullYear() > this.publish_endTime;
          }
        },
      },
      pickerEndAuditYear: {
        disabledDate: (time) => {
          return time.getFullYear() < this.publish_time;
        },
      },
      current_page: 1,
      lawsType: [
        {
          value: "中央法规",
          label: "中央法规",
        },
        {
          value: "地方法规",
          label: "地方法规",
        },
        {
          value: "法律文书",
          label: "法律文书",
        },
      ],
      categoryList: [],
      eff_levelLabel: "",
      thematic_classLabel: "",
      pub_departmentLabel: "",
      timelinessLabel: "",
      reg_categoryLabel: "",
      CategoryLabel: "",
      select: "title",
    };
  },
  created() {
    if (window.sessionStorage.getItem("laws")) {
      window.sessionStorage.removeItem("laws");
      // let retain = JSON.parse(window.sessionStorage.getItem("laws"));
      // this.regulations = retain;
      // retain.forEach((item) => {
      //   if (item.type == "title") {
      //     // this.simpleSearch = JSON.parse(this.simpleSearch);
      //     this.searchParameter.title = item.name;
      //   }
      //   if (item.type == "text") {
      //     // this.simpleSearch = JSON.parse(this.simpleSearch);
      //     this.searchParameter.content = item.name;
      //   }
      //   if (item.type == "hyphen") {
      //     // this.simpleSearch = JSON.parse(this.simpleSearch);
      //     this.searchParameter.content = item.name;
      //   }
      //   if (item.type == "Eff") {
      //     this.searchParameter.eff_level = item.name;
      //   }
      //   if (item.type == "Pub") {
      //     this.searchParameter.pub_department = item.name;
      //   }
      //   if (item.type == "Time") {
      //     this.publish_time = item.name;
      //     if (item.end) {
      //       this.publish_endTime = item.name;
      //       this.pub_time_Vue = {
      //         start: item.name + "-01-01",
      //         end: item.end + "-12-31",
      //       };
      //     } else {
      //       this.pub_time_Vue = {
      //         start: item.name + "-01-01",
      //         end: item.name + "-12-31",
      //       };
      //     }
      //   }
      //   if (item.type == "Reg") {
      //     this.searchParameter.reg_category = item.name;
      //   }
      //   if (item.type == "Topic") {
      //     this.searchParameter.thematic_class = item.name;
      //   }
      //   if (item.type == "Aging") {
      //     this.searchParameter.timeliness = item.name;
      //   }
      // });
    }
    this.statuteList();
    this.statuteSift();
  },
  methods: {
    toCase() {
      //   window.sessionStorage.setItem("searchinput", "");
      window.sessionStorage.setItem("laws", "");
      this.$router.push({ path: "/lawsStatute" });
    },
    onSubmit() {

      this.regulations = [];
      window.sessionStorage.removeItem("laws");
      let aa = 1;
      if (this.publish_time == null && this.publish_endTime == null) {
        this.publish_time = "";
        this.publish_endTime = "";
        this.pub_time_Vue = { start: "", end: "" }; //发布日期
      } else if (this.publish_time == null || this.publish_endTime == null) {
        this.$message({
          message: "请选择发布年份",
          type: "warning",
        });
        aa = 0;
      }
      if (aa !== 0) {
        if (this.searchParameter.title !== "") {
          //标题
          let title = {
            name: this.searchParameter.title,
            type: "title",
          };
          this.regulations.push(title);
          this.thematic_classLabel=""
        }
        if (this.searchParameter.content !== "") {
          //全文
          let text = {
            name: this.searchParameter.content,
            type: "text",
          };
          this.regulations.push(text);
        }
        if (this.searchParameter.iss_num !== "") {
          //发文字号
          let hyphen = {
            name: this.searchParameter.iss_num,
            type: "hyphen",
          };
          this.regulations.push(hyphen);
          this.eff_levelLabel=""
          this.pub_departmentLabel=""
          this.publish_time ==""
          this.publish_endTime == ""
          this.reg_categoryLabel == ""
          this.thematic_classLabel == ""
          this.timelinessLabel == ""
        }
        if (this.eff_levelLabel !== "") {
          //效力级别
          let eff = {
            name: this.eff_levelLabel,
            type: "Eff",
          };
          this.regulations.push(eff);
          this.searchParameter.eff_level = JSON.stringify([
            this.eff_levelLabel,
          ]);
        } else {
          this.searchParameter.eff_level = "";
        }
        if (this.pub_departmentLabel !== "") {
          //发布部门
          let put = {
            name: this.pub_departmentLabel,
            type: "Pub",
          };
          this.regulations.push(put);
          this.searchParameter.pub_department = JSON.stringify([
            this.pub_departmentLabel,
          ]);
        } else {
          this.searchParameter.pub_department = "";
        }
        if (this.publish_time !== "" && this.publish_endTime !== "") {
          //发布年份
          let time = {
            name: this.publish_time,
            end: this.publish_endTime,
            type: "Time",
          };
          this.regulations.push(time);
          // this.searchParameter.pub_time = data.key_as_string;
          this.pub_time_Vue = {
            start: this.publish_time + "-01-01",
            end: this.publish_endTime + "-12-31",
          };
        }
        if (this.reg_categoryLabel !== "") {
          //法规类别
          let reg = {
            name: this.reg_categoryLabel,
            type: "Reg",
          };
          this.regulations.push(reg);
          this.searchParameter.reg_category = JSON.stringify([
            this.reg_categoryLabel,
          ]);
        } else {
          this.searchParameter.reg_category = "";
        }
        if (this.thematic_classLabel !== "") {
          //专题分类
          let topic = {
            name: this.thematic_classLabel,
            type: "Topic",
          };
          this.regulations.push(topic);
          this.searchParameter.thematic_class = JSON.stringify([
            this.thematic_classLabel,
          ]);
        } else {
          this.searchParameter.thematic_class = "";
        }
        if (this.timelinessLabel !== "") {
          //时效性
          let aging = {
            name: this.timelinessLabel,
            type: "Aging",
          };
          this.regulations.push(aging);
          this.searchParameter.timeliness = JSON.stringify([
            this.timelinessLabel,
          ]);
        } else {
          this.searchParameter.timeliness = "";
        }
        if (this.CategoryLabel !== "") {
          //时效性
          let Category = {
            name: this.CategoryLabel,
            type: "Aging",
          };
          this.regulations.push(Category);
          this.searchParameter.doc_category = JSON.stringify([
            this.CategoryLabel,
          ]);
        } else {
          this.searchParameter.doc_category = "";
        }
        //   console.log(this.regulations)
        window.sessionStorage.setItem("laws", JSON.stringify(this.regulations));
        this.loading_box = true;
        // this.loadNode = true;
        if (this.picked == false) {
          this.picked = true;
          this.sortShow = true;
        }
        this.defaultsort = [
          {
            value: "",
            label: "相关度",
          },
          {
            value: "asc",
            label: "↑ 发布时间",
          },
          {
            value: "desc",
            label: "↓ 发布时间",
          },
          {
            value: "asc0",
            label: "↑ 实施时间",
          },
          {
            value: "desc0",
            label: "↓ 实施时间",
          },
        ];
        this.valuesort = "";
        this.type_vue = "中央法规";
        this.group = "效力级别";
        this.statuteList();
        this.statuteSift();
      }
      console.log(this.regulations)
    },
    resetForm(form) {
   
      this.regulations = [];
      window.sessionStorage.removeItem("laws");
      this.searchParameter = {
        page: 1,
        pagesize: 20,
        search: "", //文本框检索
        iss_num: "", //发文字号
        pub_time: "", //发布日期
        imp_time: "", //实施日期
        timeliness: "", //时效性
        eff_level: "", //效力级别
        reg_category: "", //法规类别
        failure_basis: "", //失效依据
        content: "", //全文
        pub_department: "", //发布部门
        title: "", //标题
        thematic_class: "", //专题分类
        iss_num: "", //发文字号
        type: "", //类型：中央法规；地方法规 ;法律文书
        order: "", //排序
        doc_category: "",
      };
      this.eff_levelLabel = "";
      this.thematic_classLabel = "";
      this.pub_departmentLabel = "";
      this.timelinessLabel = "";
      this.reg_categoryLabel = "";
      this.CategoryLabel = "";
      this.group = "效力级别";
      this.publish_time = "";
      this.publish_endTime = "";
      (this.pub_time_Vue = { start: "", end: "" }), //发布日期
        (this.loading_box = true);
      this.loadNode = true;
      this.statuteList();
      this.statuteSift();
    },
    //   获取法律法规列表数据
    statuteList() {
      this.searchParameter.search = JSON.stringify(this.search_Vue);
      this.searchParameter.pub_time = JSON.stringify(this.pub_time_Vue);
      this.searchParameter.imp_time = JSON.stringify(this.imp_time_Vue);
      this.searchParameter.order = JSON.stringify(this.order_vue);
      this.searchParameter.type = JSON.stringify([this.type_vue]);
      // this.$http
      //   .post("/lawreg", this.searchParameter)
      //   .then((res) => {
      //     // console.log(res);
      //     this.totalCount = res.data.data.list.total.value;
      //     this.lawList = res.data.data.list.hits;
      //     this.loading_box = false;
      //   })
      //   .catch((error) => {
      //     console.log(error);
      //   });
      this.$set(this.searchParameter, "group_by", this.group);
      this.$http
        .post("/newlawreg", this.searchParameter)
        .then((res) => {
          // console.log(res);
          this.categoryList = [];
          this.lawList = [];
          if (this.searchParameter.group_by == "") {
            this.totalCount = res.data.data.list.total.value;
            this.lawList = res.data.data.list.hits;
            this.loading_box = false;
          } else {
            // console.log(res.data.data.length);
            if (res.data.data.length <= 1) {
              this.totalCount = res.data.data[0].list.total.value;
              this.lawList = res.data.data[0].list.hits;
              this.loading_box = false;
            } else {
              this.categoryList = res.data.data;
              this.loading_box = false;
              this.totalCount = 0;
              this.categoryList.forEach((item) => {
                this.totalCount = this.totalCount + item.list.total.value;
              });
              this.loading_box = false;
            }
            // if (
            //   this.searchParameter.timeliness == "" &&
            //   this.searchParameter.eff_level == "" &&
            //   this.searchParameter.reg_category == "" &&
            //   this.searchParameter.pub_department == "" &&
            //   this.searchParameter.thematic_class == ""
            // ) {
            //   this.lawList = [];

            //   this.categoryList = res.data.data;
            //   this.loading_box = false;
            //   this.totalCount = 0;
            //   this.categoryList.forEach((item) => {
            //     this.totalCount = this.totalCount + item.list.total.value;
            //   });
            //   this.loading_box = false;
            // } else {
            //   this.totalCount = res.data.data[0].list.total.value;
            //   this.lawList = res.data.data[0].list.hits;
            //   this.loading_box = false;
            // }

            // console.log(this.totalCount);
          }

          // this.totalCount =
        })
        .catch((error) => {
          console.log(error);
        });
    },
    //   获取法律法规筛选数据
    statuteSift() {
      this.searchParameter.search = JSON.stringify(this.search_Vue);
      this.searchParameter.pub_time = JSON.stringify(this.pub_time_Vue);
      this.searchParameter.imp_time = JSON.stringify(this.imp_time_Vue);
      this.searchParameter.order = JSON.stringify(this.order_vue);
      this.searchParameter.type = JSON.stringify([this.type_vue]);
      if (this.searchParameter.hasOwnProperty("group_by")) {
        // delete this.searchParameter.group_by;
        this.searchParameter.group_by = this.group;
      } else {
        this.$set(this.searchParameter, "group_by", this.group);
      }

      this.$http
        .post("/regcategory", this.searchParameter)
        .then((res) => {
          // console.log(res);
          this.leftData = res.data.data;
          this.Eff_level = []; //效力级别

          this.Pub_Department = []; //发布部门

          this.Pub_Time = []; //发布年份

          this.Reg_Category = []; //法规类别

          // this.Timeliness = []; //时效性
          this.Thematic = [];
          this.DocCategory = [];
          console.log(res.data.data.Timeliness.length,this.Timeliness.length,"222222222")
          if (res.data.data.Timeliness.length< this.Timeliness.length) {
            this.Timeliness =  this.Timeliness; //时效性
          }else{
            this.Timeliness = res.data.data.Timeliness; //时效性
          }
                
          if (res.data.data.Eff_level) {
            this.Eff_level = res.data.data.Eff_level; //效力级别
            // console.log(this.Eff_level);
          }
          if (res.data.data.Pub_Department) {
            this.Pub_Department = res.data.data.Pub_Department; //发布部门
          }
          if (res.data.data.Pub_Time) {
            this.Pub_Time = res.data.data.Pub_Time; //发布年份
          }
          if (res.data.data.Reg_Category) {
            this.Reg_Category = res.data.data.Reg_Category; //法规类别
          }
          if (res.data.data.Thematic) {
            this.Thematic = res.data.data.Thematic; //专题分类
          }
         
          if (res.data.data.Doc_Category) {
            this.DocCategory = res.data.data.Doc_Category; //时效性
          }
          this.eff_options = [];
          this.thematic_options = [];
          this.pub_options = [];
          this.timeliness_options = [];
          this.reg_options = [];
          this.Category_options = [];
          this.DocCategory.forEach((item) => {
            let doc01 = {
              value: item.name,
              label: item.name,
            };
            this.Category_options.push(doc01);
            if (item.children.length > 0) {
              item.children.forEach((item01) => {
                let doc02 = {
                  value: item01.name,
                  label: item01.name,
                };
                this.Category_options.push(doc02);
              });
            }
          });
          this.Eff_level.forEach((item) => {
            let eff01 = {
              value: item.name,
              label: item.name,
            };
            this.eff_options.push(eff01);
            if (item.children.length > 0) {
              item.children.forEach((item01) => {
                let eff02 = {
                  value: item01.name,
                  label: item01.name,
                };
                this.eff_options.push(eff02);
              });
            }
          });
          this.Pub_Department.forEach((item) => {
            let Pub01 = {
              value: item.name,
              label: item.name,
            };
            this.pub_options.push(Pub01);

            if (item.children.length > 0) {
              item.children.forEach((item02, index) => {
                let Pub03 = {
                  value: item02.name,
                  label: item02.name,
                  //   val:index,
                };
                this.pub_options.push(Pub03);
              });
            }
          });
          this.Reg_Category.forEach((item) => {
            let eff01 = {
              value: item.name,
              label: item.name,
            };
            this.reg_options.push(eff01);
            if (item.children.length > 0) {
              item.children.forEach((item01) => {
                let eff02 = {
                  value: item01.name,
                  label: item01.name,
                };
                this.reg_options.push(eff02);
              });
            }
          });
          this.Thematic.forEach((item) => {
            let eff01 = {
              value: item.name,
              label: item.name,
            };
            this.thematic_options.push(eff01);
            if (item.children.length > 0) {
              item.children.forEach((item01) => {
                let eff02 = {
                  value: item01.name,
                  label: item01.name,
                };
                this.thematic_options.push(eff02);
              });
            }
          });
          this.Timeliness.forEach((item) => {
            let eff01 = {
              value: item.key,
              label: item.key,
            };
            this.timeliness_options.push(eff01);
          });
          this.loadNode = false;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    // 检索框检索
    newSearch() {
      // console.log(this.input);
      this.search_Vue.word = this.input;
      this.searchParameter.page = 1;
      this.current_page = 1;
      this.statuteList();
      // this.statuteSift();
      this.regulations = [];
      if (this.input !== "") {
        let search_tag = {
          type: "input",
          name: this.input,
        };
        this.regulations.push(search_tag);
        window.sessionStorage.setItem("laws", JSON.stringify(this.regulations));
      } else {
        window.sessionStorage.removeItem("laws");
      }
    },
    // 高级检索
    seniorCase() {
      this.$router.push({ path: "/advancedLaws" });
      //  window.sessionStorage.removeItem("laws");
    },
    // 修改检索精准度
    accuracy(type) {
      // console.log(type);
      this.search_Vue.type = type;
    },
    // 删除检索 / 筛选 条件
    handleClose(type, index) {
      this.regulations.splice(index, 1);
      window.sessionStorage.setItem("laws", JSON.stringify(this.regulations));
      if (this.regulations.length == 0) {
        this.searchParameter = {
          page: 1,
          pagesize: 20,
          search: "", //文本框检索
          iss_num: "", //发文字号
          pub_time: "", //发布日期
          imp_time: "", //实施日期
          timeliness: "", //时效性
          eff_level: "", //效力级别
          reg_category: "", //法规类别
          failure_basis: "", //失效依据
          content: "", //全文
          pub_department: "", //发布部门
          title: "", //标题
          thematic_class: "", //专题分类
          iss_num: "", //发文字号
          type: "", //类型：中央法规；地方法规 ;法律文书
          order: "", //排序
          doc_category: "",
        };
        this.search_Vue = { word: "", type: this.radio01, field: this.select }; //文本框检索
         this.resetForm()
      } else if (type == "Eff") {
        this.searchParameter.eff_level = "";
      } else if (type == "Pub") {
        this.searchParameter.pub_department = "";
      } else if (type == "Time") {
        // this.searchParameter.pub_time = "";
        this.pub_time_Vue = { start: "", end: "" }; //发布日期
      } else if (type == "Reg") {
        this.searchParameter.reg_category = "";
      } else if (type == "Topic") {
        this.searchParameter.thematic_class = "";
      } else if (type == "Aging") {
        this.searchParameter.timeliness = "";
      } else {
        this.search_Vue = { word: "", type: this.radio01, field: this.select };
      }
      this.loading_box = true;
      // this.loadNode = true;
      this.searchParameter.page = 1;
      this.current_page = 1;
      if (this.picked == false) {
        this.picked = true;
        this.sortShow = true;
      }
      this.statuteList();
      // this.statuteSift();
    },
    // 清空检索条件
    remove() {
      this.regulations = [];
      window.sessionStorage.removeItem("laws");
      this.searchParameter = {
        page: 1,
        pagesize: 20,
        search: "", //文本框检索
        iss_num: "", //发文字号
        pub_time: "", //发布日期
        imp_time: "", //实施日期
        timeliness: "", //时效性
        eff_level: "", //效力级别
        reg_category: "", //法规类别
        failure_basis: "", //失效依据
        content: "", //全文
        pub_department: "", //发布部门
        title: "", //标题
        thematic_class: "", //专题分类
        iss_num: "", //发文字号
        type: "", //类型：中央法规；地方法规 ;法律文书
        order: "", //排序
        doc_category: "",
      };
      this.search_Vue = { word: "", type: this.radio01, field: this.select }; //文本框检索
      (this.pub_time_Vue = { start: "", end: "" }), //发布日期
        (this.loading_box = true);
      // this.loadNode = true;
      this.searchParameter.page = 1;
      this.current_page = 1;
      if (this.picked == false) {
        this.picked = true;
        this.sortShow = true;
      }
      this.statuteList();
      // this.statuteSift();
    },
    // 筛选
    briefClick(data, node, item, type) {
      // console.log(data, node, item, type);
      // console.log(this.regulations);
      // let repeat = 0;
      // if (item.type == "Eff") {
      //   this.regulations.splice(index, 1);
      // }
      // if (item.type == "Pub") {
      //   this.regulations.splice(index, 1);
      // }
      // if (item.type == "Time") {
      //   this.regulations.splice(index, 1);
      // }
      // if (item.type == "Reg") {
      //   this.regulations.splice(index, 1);
      // }
      // if (item.type == "Topic") {
      //   this.regulations.splice(index, 1);
      // }
      // if (item.type == "Aging") {
      //   this.regulations.splice(index, 1);
      // }
      // this.regulations.forEach((item, index) => {
      //   // if (item.name == data.name) {
      //   //   repeat = 1;
      //   // }
      // });
      // if (repeat !== 1) {
      if (type == "Eff_level") {
        //效力级别
        let eff = {
          name: data.name,
          type: "Eff",
        };
        this.regulations.forEach((item, index) => {
          if (item.type == "Eff") {
            this.regulations.splice(index, 1);
          }
        });
        this.regulations.push(eff);
        this.searchParameter.eff_level = JSON.stringify([data.name]);
        // this.searchParameter01.eff_level = data.name;
        this.eff_levelLabel = data.name;
      }
      if (type == "Pub_Department") {
        //发布部门
        let put = {
          name: data.name,
          type: "Pub",
        };
        this.regulations.forEach((item, index) => {
          if (item.type == "Pub") {
            this.regulations.splice(index, 1);
          }
        });
        this.regulations.push(put);
        this.searchParameter.pub_department = JSON.stringify([data.name]);
        this.pub_departmentLabel = data.name;
      }
      if (type == "Pub_Time") {
        //发布年份
        let time = {
          name: data.key_as_string,
          type: "Time",
        };
        this.regulations.forEach((item, index) => {
          if (item.type == "Time") {
            this.regulations.splice(index, 1);
          }
        });
        this.regulations.push(time);
        // this.searchParameter.pub_time = data.key_as_string;
        this.pub_time_Vue = {
          start: data.key_as_string + "-01-01",
          end: data.key_as_string + "-12-31",
        };
        this.publish_time = data.key_as_string;
        this.publish_endTime = data.key_as_string;
      }
      if (type == "Reg_Category") {
        //法规类别
        let reg = {
          name: data.name,
          type: "Reg",
        };
        this.regulations.forEach((item, index) => {
          if (item.type == "Reg") {
            this.regulations.splice(index, 1);
          }
        });
        this.regulations.push(reg);
        this.searchParameter.reg_category = JSON.stringify([data.name]);
        this.reg_categoryLabel = data.name;
      }
      if (type == "Thematic") {
        //专题分类
        let topic = {
          name: data.name,
          type: "Topic",
        };
        this.regulations.forEach((item, index) => {
          if (item.type == "Topic") {
            this.regulations.splice(index, 1);
          }
        });
        this.regulations.push(topic);
        this.searchParameter.thematic_class = JSON.stringify([data.name]);
        this.thematic_classLabel = data.name;
      }
      if (type == "Timeliness") {
        //时效性
        let aging = {
          name: data.key,
          type: "Aging",
        };
        this.regulations.forEach((item, index) => {
          if (item.type == "Aging") {
            this.regulations.splice(index, 1);
          }
        });
        this.regulations.push(aging);
        this.searchParameter.timeliness = JSON.stringify([data.key]);
        this.timelinessLabel = data.name;
      }
      window.sessionStorage.setItem("laws", JSON.stringify(this.regulations));
      this.loading_box = true;
      // this.loadNode = true;
      this.searchParameter.page = 1;
      this.current_page = 1;
      if (this.picked == false) {
        this.picked = true;
        this.sortShow = true;
      }
      this.statuteList();
      this.statuteSift();
      // }
    },
    showAll(type) {
      if (type == "Eff_level") {
        this.levelAll = true;
        this.levelShow = false;
      }
      if (type == "Pub_Department") {
        this.departmentAll = true;
        this.departmentShow = false;
      }
      if (type == "Pub_Time") {
        this.timeAll = true;
        this.timeShow = false;
      }
      if (type == "Reg_Category") {
        this.categoryAll = true;
        this.categoryShow = false;
      }
      if (type == "Thematic") {
        this.thematicAll = true;
        this.thematicShow = false;
      }
      if (type == "Timeliness") {
        this.timelinesAll = true;
        this.timelinesShow = false;
      }
      if (type == "DocCategory") {
        this.CategoryAll = true;
        this.CategoryShow = false;
      }
    },
    // 分组筛选
    packet() {
      // this.regulations = [];
      // window.sessionStorage.removeItem("laws");
      // this.searchParameter = {
      //   page: 1,
      //   pagesize: 20,
      //   search: "", //文本框检索
      //   iss_num: "", //发文字号
      //   pub_time: "", //发布日期
      //   imp_time: "", //实施日期
      //   timeliness: "", //时效性
      //   eff_level: "", //效力级别
      //   reg_category: "", //法规类别
      //   failure_basis: "", //失效依据
      //   content: "", //全文
      //   pub_department: "", //发布部门
      //   title: "", //标题
      //   thematic_class: "", //专题分类
      //   iss_num: "", //发文字号
      //   type: "", //类型：中央法规；地方法规 ;法律文书
      //   order: "", //排序
      //   doc_category: "",
      // };
      // this.search_Vue = { word: "", type: this.radio01, field: this.select }; //文本框检索
      // (this.pub_time_Vue = { start: "", end: "" }), //发布日期
      //   (this.loading_box = true);
      // // this.loadNode = true;
      // this.searchParameter.page = 1;
      // this.current_page = 1;
      if (this.picked == false) {
        this.picked = true;
        this.sortShow = true;
      }
      this.statuteList();
    },
    // 排序方式
    itemsort(a, b) {
      // console.log(this.valuesort);
      // console.log(a);
      if (this.valuesort !== a) {
        if (a == "") {
          this.order_vue.field = "";
        }
        if (b == "↑ 发布时间" || b == "↓ 发布时间") {
          this.order_vue.field = "Pub_Time";
          this.order_vue.type = a;
        }
        if (b == "↑ 实施时间" || b == "↓ 实施时间") {
          this.order_vue.field = "Imp_Time";
          if (a == "asc0") {
            this.order_vue.type = "asc";
          } else {
            this.order_vue.type = "desc";
          }
        }

        this.loading_box = true;
        // this.loadNode = true;
        this.searchParameter.page = 1;
        this.current_page = 1;
        if (this.picked == false) {
          this.picked = true;
          this.sortShow = true;
        }
        this.statuteList();
        // this.statuteSift();
      }
    },
    //
    laws_Type(type) {
      if (this.searchParameter.type !== this.type_vue) {
        // this.searchParameter.type = type;
        if (this.type_vue == "法律文书") {
          this.group = "文书分类";
          this.groupsType = [
            {
              value: "文书分类",
              label: "文书分类",
            },
            {
              value: "",
              label: "不分组",
            },
          ];
          if (this.search_Vue.word !== "") {
            this.defaultsort = [
              {
                value: "",
                label: "相关度",
              },
              {
                value: "asc",
                label: "↑ 发布时间",
              },
              {
                value: "desc",
                label: "↓ 发布时间",
              },
            ];

            this.valuesort = "";
          } else {
            this.defaultsort = [
              {
                value: "asc",
                label: "↑ 发布时间",
              },
              {
                value: "desc",
                label: "↓ 发布时间",
              },
            ];
            this.valuesort = "desc";
          }
          this.order_vue.field = "Pub_Time";
          // this.searchParameter.doc_category = "";
        } else {
          this.group = "效力级别";
          this.group = "效力级别";
          if (this.search_Vue.word !== "") {
            this.defaultsort = [
              {
                value: "",
                label: "相关度",
              },
              {
                value: "asc",
                label: "↑ 发布时间",
              },
              {
                value: "desc",
                label: "↓ 发布时间",
              },
              {
                value: "asc0",
                label: "↑ 实施时间",
              },
              {
                value: "desc0",
                label: "↓ 实施时间",
              },
            ];
            this.valuesort = "";
          } else {
            this.defaultsort = [
              {
                value: "asc",
                label: "↑ 发布时间",
              },
              {
                value: "desc",
                label: "↓ 发布时间",
              },
              {
                value: "asc0",
                label: "↑ 实施时间",
              },
              {
                value: "desc0",
                label: "↓ 实施时间",
              },
            ];
            this.valuesort = "desc0";
          }
          this.groupsType = [
            {
              value: "效力级别",
              label: "效力级别",
            },
            {
              value: "时效性",
              label: "时效性",
            },
            {
              value: "",
              label: "不分组",
            },
          ];
          // this.searchParameter.doc_category = "";
        }
        this.type_vue = type;
        this.loading_box = true;
        this.loadNode = true;
        if (this.picked == false) {
          this.picked = true;
          this.sortShow = true;
        }
        this.statuteList();
        this.statuteSift();
      }
    },
    moreLevel(allName) {
      // console.log(allName);
      if (this.group == "效力级别") {
        let eff = {
          name: allName,
          type: "Eff",
        };
        this.regulations.forEach((item, index) => {
          if (item.type == "Eff") {
            this.regulations.splice(index, 1);
          }
        });
        this.regulations.push(eff);
        this.searchParameter.eff_level = JSON.stringify([allName]);
      } else if (this.group == "时效性") {
        let aging = {
          name: allName,
          type: "Aging",
        };
        this.regulations.push(aging);
        this.searchParameter.timeliness = JSON.stringify([allName]);
      } else {
      }
      this.statuteList();
    },
    // 切换列表 、 可视化
    dataType(type) {
      // this.picked = !this.picked;
      if (type == "list") {
        if (this.picked == true) {
          this.picked = false;
          this.sortShow = false;
        }
      }
      if (type == "chart") {
        if (this.picked == false) {
          this.picked = true;
          this.sortShow = true;
        }
      }
    },
    collectible(it) {
      // console.log("a");
      if (store.getCookie("user_id") == "3") {
        let collOne = {
          // user_id: store.getCookie("user_id"),
          docid: it._id,
          // role: store.getCookie("role"),
          doctype: 3,
          docname: it._source.Title,
        };
        this.$http
          .post("/coll", collOne)
          .then((res) => {
            // console.log(res);
            this.$message({
              message: res.data.message,
              type: "success",
            });
            this.statuteList();
          })
          .catch((error) => {
            console.log(error);
          });
      } else {
        this.$message({
          message: "请登录个人账号！！",
          type: "warning",
        });
      }
    },
    cancel(it) {
      // console.log("a");
      if (store.getCookie("user_id") == "3") {
        let collOne = {
          id: it._id,
        };
        this.$http
          .post("/delcoll", collOne)
          .then((res) => {
            // console.log(res);
            this.$message({
              message: res.data.message,
              type: "success",
            });
            this.statuteList();
          })
          .catch((error) => {
            console.log(error);
          });
      } else {
        this.$message({
          message: "请登录个人账号！！",
          type: "warning",
        });
      }
    },
    // 单篇下载
    down(id, type) {
      // console.log(id, type);
      if (type == "word") {
        this.$http
          .get("/law/word?id=" + id, {})
          .then((res) => {
            // console.log(res);
            if (res.data.data.url) {
              window.open(res.data.data.url, "_blank");
            }
          })
          .catch((error) => {
            console.log(error);
          });
      }
      if (type == "pdf") {
        this.$http
          .get("/law/pdf?id=" + id, {})
          .then((res) => {
            // console.log(res);
            if (res.data.data.url) {
              window.open(res.data.data.url, "_blank");
            }
          })
          .catch((error) => {
            console.log(error);
          });
      }
    },
    // 翻页
    handleCurrentChange(val) {
      this.searchParameter.page = val;
      this.current_page = val;
      this.loading_box = true;
      this.statuteList();
      window.scrollTo(0, 0);
    },
    reloads() {
      // 移除组件
      this.update = false;
      // 在组件移除后，重新渲染组件
      // this.$nextTick可实现在DOM 状态更新后，执行传入的方法。
      this.$nextTick(() => {
        this.update = true;
      });
    },
  },
};
</script>

<style lang="less" scoped>
.background_box {
  // background: #f3ede3;
  background: rgb(245, 239, 228);
}
/deep/ .el-select .el-input.is-focus .el-input__inner {
     border-color: #DCDFE6 !important;
}
/deep/ .el-select .el-input__inner:focus{
  border-color:  #DCDFE6 !important;
}
/deep/ .el-input__inner{
   border-color:  #DCDFE6;
}
.laws_statute {
  width: 100%;
  background: url("../../../assets/imgs/raphael-schaller-GkinCd2enIY-unsplash.png");
  background-size: 100% 1000px;
  background-repeat: no-repeat;
  // min-width: 1800px;
  //  style="width: 30px; height: 30px; margin-right: 10px"
  // font-weight: 900; font-size: 18px"
  .case {
    width: 1350px;
    min-width: 1350px;
    max-width: 1350px;
    margin: auto;
    .breadcrumb {
      margin: 20px 0;
    }
    .advanced_search {
      // margin-left: ;
      display: flex;
      justify-content: center;
      // border: 1px solid rgb(146, 146, 146);
      border-radius: 10px;
      margin: 0 0 10px 10px;
      padding: 20px 0 0 0;
      // background: white;
      /deep/ .el-input__inner {
        background: #f7f1eb;
      }
      .carousel {
        padding: 20px 20px 20px 10px;
        border-radius: 10px;
        width: 20%;
        height: 150px;
        /deep/ .el-carousel__button {
          width: 10px;
        }
        .el-carousel__item h3 {
          display: inline-block;
          height: 120px;
          display: flex;
          align-items: center;
          justify-content: center;
          color: #475669;
          font-size: 14px;
          opacity: 0.75;
          // line-height: 50px;
          margin: 0;
          span {
            display: inline-block;
          }
        }

        .el-carousel__item:nth-child(2n) {
          // background-color: #99a9bf;
          background-image: url("../../../assets/imgs/背景图/raphael-schaller-GkinCd2enIY-unsplash.png");
          background-size: 100% 100%;
        }

        .el-carousel__item:nth-child(2n + 1) {
          // background-image: url('../../../assets/imgs/背景图/9760eac49571416.jpg');
          background-image: url("../../../assets/imgs/背景图/raphael-schaller-GkinCd2enIY-unsplash.png");
          background-size: 100% 100%;
        }
      }
      .el-tabs {
        width: 79%;
        .el-tab-pane {
          .el-popover {
          }
          .el-input {
            // height: 20px;
            /deep/ .el-input__inner {
              // border-radius: 0;
            }
          }
          .el-button {
            margin: 0;
            border: 0;
            // border-radius: 0;
          }
        }
      }
      /deep/ .el-popover--plain {
        margin-left: 700px;
      }
    }
  }
}
.conditions {
  display: flex;
  line-height: 32px;
  justify-content: space-between;
  margin: 10px 0;

  .condition {
    position: relative;

    .eltags {
      display: inline-block;
      max-width: 610px;
      margin-left: 60px;
    }

    .el-tag {
      margin: 0 0 5px 5px;
    }
  }

  .savebtn :hover {
    color: #409eff;
    cursor: pointer;
  }
}
.conditions {
  display: flex;
  line-height: 32px;
  width: 90%;
  min-height: 50px;
  justify-content: space-between;
  margin: 0 auto;
  margin-bottom: 10px;
  .condition {
    position: relative;
    .eltags {
      display: inline-block;
      max-width: 610px;
      margin-left: 60px;
    }
    .el-tag {
      margin: 0 0 5px 5px;
    }
  }
  .savebtn :hover {
    color: #409eff;
    cursor: pointer;
  }
}
.box_botton {
  display: flex;
  .box_left {
    width: 20%;
    max-width: 20%;
    padding: 0 10px 10px 0px;
    margin-right: 1%;
    border-radius: 5px;
    margin-bottom: 2%;
    /deep/ .el-menu {
      // padding: 0 0px 0px 10px;
      // background: white;
      // border: none;
      // border-radius: 10px;
      background: #faf1e8 !important;
      background-color: #faf1e8 !important;
      border: none;
      border-radius: 10px;
    }
    /deep/ .el-submenu {
    }
    h2 {
      margin: 10px 0;
      font-weight: 600;
      span {
        font-size: 28px;
        color: chocolate;
        font-weight: 600;
      }
    }
  }
  .box_right {
    width: 80%;
  }
}
// 查看更多 样式
.more {
  cursor: pointer;
  color: #409eff;
  height: 30px;
  width: 100%;
  display: inline-block;
  display: flex;
  justify-content: center;
  align-items: center;
}
.el-tree {
  background: #faf1e8;
}
.bac {
  /deep/ .el-input__inner {
    background: none;
  }
  /deep/ .el-select .el-input.is-focus .el-input__inner {
    border-color: #030303;
  }
  // /deep/ .el-select /deep/ .el-input.is-focus /deep/ .el-input__inner {
  //   border-color: #dcdfe6;
  // }
  /deep/ .el-input.is-focus {
    border-color: #dcdfe6;
  }
}
// 侧边筛选高度
.sift_tree::-webkit-scrollbar {
  display: none;
}
.sift_tree {
  max-height: 450px;
  overflow-x: hidden;
  // overflow-y: scroll;
}
// 侧边筛选高度
.sift_tree::-webkit-scrollbar {
  display: none;
}
.sift_tree {
  max-height: 450px;
  overflow-x: hidden;
  // overflow-y: scroll;
}
.sift_tree {
  /deep/ .el-tree-node:focus > .el-tree-node__content {
    /*设置选中的样式 */
    // background-color: #dde9ff !important;
    background: none !important;
  }
  /deep/ .el-tree-node__content {
    /*设置选中的样式 */
    // background-color: #dde9ff !important;
    background: none !important;
    // color: #e6a23c  !important;
  }
  /deep/ .el-tree-node__content:hover {
    /*设置鼠标飘过的颜色 */
    // background: #eaf9ff !important;
    color: #e6a23c !important;

    background: none !important;
    .custom-tree-node {
      span {
        // font-weight: 900 !important;
      }
    }
  }
  /deep/ .el-tree-node__label {
  }

  /deep/
    .el-tree--highlight-current
    .el-tree-node.is-current
    > .el-tree-node__content {
    /*current选中的样式 */
    color: #e4b453;
    font-weight: bold;
    background: none !important;
    // background-color: #dde9ff !important;
  }
  /deep/ .custom-tree-node {
    // display: inline-block;
    padding-right: 10px;
  }
}
.box_right {
  width: 80%;
  // background: white;
  .box_right_top {
    padding: 10px;
    // background: white;
    border-radius: 5px;
    display: flex;
    justify-content: space-between;
    .el-select {
      width: 110px;
      height: 10px;
      color: violet !important;
    }
  }
  .types {
    .listPick {
      // color: #409eff;
      // background: #ecf5ff;
      // border-color: #b3d8ff;
      // border-radius: 4px;
      color: #ddb361;
      background: #faf1ea;
      border-color: #ddb361;
    }
    .EChart {
      background: none !important;
    }
    .el-button:hover {
      // color: #409eff;
      // border-color: #c6e2ff;
      // background-color: #ecf5ff;
      color: #ddb361;
      background: #faf1ea;
      border-color: #ddb361;
    }
  }
  .box_main {
    // margin-top: 20px;

    .box_main_list {
      // margin: 10px 0 20px 0px;
      margin: 10px 0 20px 0px;
      // height: 200px;
      // height: 300px;
      border-radius: 5px;
      padding: 10px;
      background: #fbf2eb;
      .title {
        position: relative;

        display: flex;
        justify-content: space-between;
        // margin-bottom: 10px;
        line-height: 28px;
        h2 {
          font-size: 16px;
          font-weight: 600;
          // margin-left: 200px;
        }
        .el-tag {
          margin: 0 0px 0 25px;
          position: absolute;
          top: 0px;
        }
      }
      .title :hover {
        // color: rgb(197, 197, 197);
        color: #cf8700;
      }
      .case {
        background: #cf8700;
        color: white;
        // display: inline-block;
        margin: 5px;
        // padding: 5px;
        border-radius: 5px;
      }
      .card {
          margin: 20px 0 0 0;
          .mores {
            display: flex;
            justify-content: center;
            span {
              display: inline-block;
              cursor: pointer;
            }
          }
          p {
            line-height: 20px;
            overflow: hidden;
            -webkit-line-clamp: 5;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-box-orient: vertical;
          }
          .hits {
            // line-height: 30px;
            display: flex;
            span {
              // display: inline-block;
              line-height: 25px !important;
            }
          }
          /deep/ .el-tabs__content {
            // background: #f0e1d5;
            background: #fbf2eb;
          }
          /deep/ .el-tabs__nav-scroll {
            .el-tabs__item.is-active {
              color: #ddb361;
              // background: #f0e1d5;
              background: #fbf2eb;
              border-right-color: #dcdfe6;
              border-left-color: #dcdfe6;
            }
          }
          /deep/ .el-tabs__nav-wrap {
            // background: #fbf2eb;
            background: #f0e1d5;
          }
        }
      .box_detail {
        margin-top: 10px;
        // height: 200px;
        background: #f0e1d5;
        padding: 18px;
        .basic {
          margin-bottom: 30px;
          font-size: 16px;
          display: flex;
          .basic_left {
            width: 15%;
            height: 56px;
            display: inline-block;
            padding: 20px 20px 10px 20px;
            border-right: 1px solid rgb(172, 112, 0);
          }
          .basic_right {
            width: 85%;
            padding-left: 10px;
            .basic_content {
              // min-width: 500px;
              // div {
              //   // display: block;
              //   line-height: 30px;
              // }
              width: 50%;
              div {
                // display: block;
                line-height: 30px;
                white-space: nowrap;
                text-overflow: ellipsis;
                overflow: hidden;
              }
            }
            // justify-content: space-around;
            // width: 500px;
            // p {
            //   // display: inline-block;
            //   height: 20px;
            //   line-height: 20px;
            //   min-width: 45%;
            //   // max-width: 50%;
            //   // margin: 5px;
            // }
          }
          .details {
            width: 85%;
            padding-left: 10px;
            overflow: hidden;
            -webkit-line-clamp: 2;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-box-orient: vertical;

            p {
              line-height: 20px;
            }
          }
        }
        .card {
          margin: 20px 0 0 0;
          .mores {
            display: flex;
            justify-content: center;
            span {
              display: inline-block;
              cursor: pointer;
            }
          }
          p {
            line-height: 20px;
            overflow: hidden;
            -webkit-line-clamp: 5;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-box-orient: vertical;
          }
          .hits {
            // line-height: 30px;
            display: flex;
            span {
              // display: inline-block;
              line-height: 25px !important;
            }
          }
          /deep/ .el-tabs__content {
            // background: #f0e1d5;
            background: #fbf2eb;
          }
          /deep/ .el-tabs__nav-scroll {
            .el-tabs__item.is-active {
              color: #ddb361;
              // background: #f0e1d5;
              background: #fbf2eb;
              border-right-color: #dcdfe6;
              border-left-color: #dcdfe6;
            }
          }
          /deep/ .el-tabs__nav-wrap {
            // background: #fbf2eb;
            background: #f0e1d5;
          }
        }
        .detail {
        }
      }
    }
  }
}
.mores {
  display: flex;
  justify-content: center;
  margin: 20px 0 0 0;
  span {
    display: inline-block;
    color: #e6a23c;
  }
  span:hover {
    color: #3ca2e6;
    cursor: pointer;
  }
}
.advancedDown {
  /deep/ .el-form-item {
    margin: 0 10px 10px 0;
    // height: 28px;
    width: 48%;
    .el-form-item__content {
      width: 75%;
      // margin-bottom: 20px;
      .el-input {
        // .el-input__inner {
        //   height: 28px;
        // }
      }
      .el-select {
        width: 100%;
      }
    }
    .el-button--primary {
      border-color: rgb(238, 198, 22);
    }
  }
}
.tit_input {
  /deep/ .el-input-group__append {
    border: none;
  }
  /deep/ .el-input-group__prepend {
    border: none;
  }
  /deep/ .el-input__inner {
    border: none;
    border-start-start-radius: 0px;
    border-end-start-radius: 0px;
    border-end-end-radius: 0px;
    border-start-end-radius: 0px;
    // background: #fef7f0;
    background: #f7f1eb;
    border-right: #b7a974 1px solid;
    border-top: #b7a974 1px solid !important;
    border-bottom: #b7a974 1px solid;
    position: relative;
    top: 0px;
    height: 43px;
  }
}
.search_button {
  border-start-start-radius: 0px;
  border-end-start-radius: 0px;
  border-end-end-radius: 4px;
  border-start-end-radius: 4px;
}
.titSelect {
  // background: #fef7f0;
  background: #f7f1eb;
  height: 43px;
  // border: none;
  border-left: #b7a974 1px solid;
  // border-top: #b7a974 1px solid !important;
  border-bottom: #b7a974 1px solid;
  border-start-start-radius: 4px;
  border-end-start-radius: 4px;
  border-end-end-radius: 0px;
  border-start-end-radius: 0px;
  /deep/ .el-input__inner {
    text-align: center;
    // border-radius: 0;
    border-start-start-radius: 4px;
    border-end-start-radius: 4px;
    border-end-end-radius: 0px;
    border-start-end-radius: 0px;
  }
  /deep/ .el-input__suffix-inner {
    // display: inline-block;
    // border: none;
    border-start-start-radius: 4px;
    border-end-start-radius: 4px;
    border-end-end-radius: 0px;
    border-start-end-radius: 0px;
    padding: 0 15px;
    // margin-top: 5px;
    position: relative;
    top: 2px;
    border-right: 1px #e8e3dd solid;
    i {
      position: relative;
      top: -2px;
    }
  }
}
.searchBtn {
  display: block;
  width: 100%;
  // height: 50px;
  /deep/.el-form-item__content {
    margin-left: 72%;
  }
}
// 列表操作功能
.el-dropdown-link {
  cursor: pointer;
}
.el-dropdown-link:hover {
  color: #409eff;
}
.el-icon-arrow-down {
  font-size: 12px;
}
// 分页按钮
.page-bar {
  margin: 10px 0;
  display: flex;
  justify-content: center;
}
.message {
  display: flex;
  justify-content: space-between;

  /deep/ .el-breadcrumb__item {
    display: inline-block;
    line-height: 28px;
  }
}
.imgTitle {
  // margin: 0 10px;
  position: relative;
  // left: -20px;
}
.grouping-title {
  position: relative;
  height: 40px;
  padding: 5px 0 5px 10px;
  margin-bottom: 10px;
  // background: #e7e7e7;
  border-radius: 5px;
  background: #f0e1d5;
  h3 {
    font-size: 18px;
    font-weight: 600;
    line-height: 30px;
    cursor: pointer;
    color: #e6a23c;
    float: left;
    display: inline-block;
  }
  span {
    font-size: 15px;
    line-height: 30px;
    color: #666;
    position: absolute;
    right: 20px;
  }
}
.more {
  text-align: center;
  margin-bottom: 20px;
  color: #666;
  i {
    font-size: 30px;
    margin: 0 10px 0 0;
  }
}
.more:hover {
}
/deep/ .el-icon-view {
  font-size: 20px;
  position: relative;
  top: 3px;
}
.packMore {
  color: #666;
}
.packMore:hover {
  color: rgb(88, 216, 255);
  cursor: pointer;
}
/deep/ .el-tree-node__content {
  // margin: 5px 15px 5px 0;
  // min-height: 40px;
}
.region {
  /deep/ .el-tree-node {
    white-space: normal;
    // padding: 10px 0;
    // max-width: 170px;
    // line-height: 25px;
    // text-align: center;
    // rgba(255, 255, 255)
    .el-tree-node__content {
      height: 100%;
      align-items: start;
      line-height: 30px;
    }
    // .el-tree-node__content {
    //   height: 100%;
    //   align-items: start;
    // }
  }
}
.cityClass {
  /deep/ .el-tree-node__content {
    // height: 60px;
    // max-height: 60px !important;
    // display: inline-block;
    // margin: 5px 5px 5px 0;
  }
  /deep/ .custom-tree-node {
    // display: inline;
    padding-right: 10px;
  }
  /deep/ .custom-tree-node {
    // margin: 10px 0;
    // padding-right: 10px;
    // width: 150px;

    // display: inline-block;
    // max-height: 50px;
  }
}
.collection {
  img {
    width: 28px;
  }
}
.collection:hover img {
  cursor: pointer;
  // content: url("../../../assets/imgs/2.0/收藏3.png");
}
/deep/ .el-tree-node__expand-icon {
  position: relative;
  top: 3px;
}
.down_icon {
  width: 20px;
  position: relative;
  top: 3px;
}
</style>